import styles from "./style.postcss";

import is from "is_js";
import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
import { Link, withRouter } from "react-router";
import ReactGA from "react-ga4";
import classnames from "classnames";
import { Map, List } from "immutable";
import { actions as Group } from "containers/Group";
import {
  checkIsUnitQuiz,
  getProgressTestPlanFromIndex,
  shouldDisabledSkillName,
  getViewerLink,
} from "data/ProgressTestsPlan/accessors";
import { fetch, buildUrl } from "domain/Api";
import { exporter } from "domain/Exporter";

import {
  AlertDialog,
  moment,
  connect,
  ApiCall,
  ApiResponseHelper,
  Config,
  ErrorDialog,
  PrivilegeChecker,
  testClass,
  Icon,
  ConfirmDialog,
  Tooltip,
  Button,
  PageCard,
  PageLoadingSpinner,
} from "omni-common-ui";

import ExpansionButton from "components/ExpansionButton";
import CourseViewTable from "components/CourseViewTable";
import * as SessionsAttendance from "data/SessionsAttendance";
import { actions as progressReportsActions } from "data/ProgressReports";
import {
  ProgressTest,
  actions as progressTestActions,
} from "data/ProgressTests";
import { actions as GroupMembers } from "data/GroupMembers";
import { actions as progressTestViewLinkActions } from "data/ProgressTests/ViewLink";
import UnsavedChangesTrackingPageComponent from "components/UnsavedChangesTrackingPageComponent";
import UnsavedChangesWarning from "components/UnsavedChangesWarning";
import Privileges from "domain/Privileges";
import NewNotePopup from "components/NewNotePopup";
import QuickSummary from "components/QuickSummary";
import { actions as notesActions } from "containers/Student/Note";

import RcTooltip from "rc-tooltip";
import EditableScoreCell from "./EditableScoreCell";

const MARKING = "edit";
const EMPTY_HYPHEN = "-";
const AssessmentReportInstruction =
  "Assessment Report will be automatically published after all scores are saved/synced from EF Small Stars PT";

const BENCHMARKING_DATA = [
  {
    range: "0-59%",
    category: "Needs Improvement",
    descriptor:
      "Your child is finding it difficult to understand and use the language and skills taught in this unit. They need extra support to practise key vocabulary and structures and to build confidence in using what they have learned.",
  },
  {
    range: "60-79%",
    category: "Developing",
    descriptor:
      "Your child is making progress with the language and skills from this unit and is beginning to use them with some success. They are close to meeting expectations but may still need support or reminders to use new vocabulary and structures accurately and consistently.",
  },
  {
    range: "80-89%",
    category: "On Track",
    descriptor:
      "Your child shows a good understanding of the language and skills taught in this unit and meets the expected learning goals. They can use the key vocabulary and structures independently in familiar activities, with only occasional mistakes.",
  },
  {
    range: "90-100%",
    category: "Outstanding",
    descriptor:
      "Your child shows an excellent understanding of the language and skills taught in this unit and uses what they have learned confidently and accurately. They apply the unit’s vocabulary and structures effectively in a range of activities and may use them flexibly or make clear connections with other learning.",
  },
];

const ONLINE_SKILLS = ["grammar", "vocabulary", "listening", "reading"];
const SHOW_REMAINING_MEMBERS_CARD = false;
const SHOW_EXAM_LOG_CARD = false;
const SHOW_ADD_STUDENT_NOTES_ICON = false;

function getExamType(name) {
  if (name === 'Midterm Exam') return 'midterm';
  if (name === 'Final Exam') return 'final';
  return null;
}

export class ProgressTestCourseView extends UnsavedChangesTrackingPageComponent {
  constructor(props) {
    super(props);

    this._renderAddNoteDialog = this._renderAddNoteDialog.bind(this);
    this._onAddNoteClicked = this._onAddNoteClicked.bind(this);
    this._onCancelNoteClicked = this._onCancelNoteClicked.bind(this);
    this._onSaveNoteClicked = this._onSaveNoteClicked.bind(this);

    this.state = {
      allowRouteLeave: false,
      isRouterLeaveConfirmed: false,
      studentProgressTestResult: new Map(),
      studentChanged: [],
      dialogOpen: false,
      retakePTConfirmDialog: false,
      showExportWarningDialog: false,
      isExportErrorOccurred: false,
      isExportInProgress: false,
      isExpandRemainingMember: true,
      isExpandMembersInScoreInfo: false,
      benchmarkingTooltipVisible: false,
    };

    this._onIndividualScoreEditedCache = {};
  }

  componentDidMount() {
    this._buildViewState(this.props);
    this._fetchProgressTestModels();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.mode !== this.props.params.mode) {
      window.getSelection().removeAllRanges();
    }
    if (nextProps.progressTest && nextProps.progressTest.data) {
      this.props.fetchProgressTestViewLinkIfNeeded(
        nextProps.progressTest.data.progressTestId,
      );
    }

    if (
      this.props.location.pathname === nextProps.location.pathname &&
      this.state.studentProgressTestResult.size &&
      nextProps.progressTest === this.props.progressTest
    ) {
      return;
    }

    this._fetchProgressTestModels(nextProps);
    this._buildViewState(nextProps);
  }

  routerWillLeave(nextLocation) {
    const that = this;
    const { studentProgressTestResult, studentChanged } = this.state;
    const returnToView = () =>
      that._forcePushRoute(that.props.buildRoute({ mode: "" }));
    if (nextLocation && nextLocation.pathname.endsWith("/save")) {
      returnToView();
      setTimeout(() => {
        if (studentChanged.length !== 0) {
          that._handleSave(
            studentProgressTestResult.filter(
              (result) =>
                studentChanged.findIndex(
                  (studentId) => studentId === result.studentId,
                ) !== -1,
            ),
          );
        }
      }, 0);
    } else if (nextLocation && nextLocation.pathname.endsWith("/discard")) {
      returnToView();
    } else {
      this.lastStateBeforeRouteChange = this.state.studentProgressTestResult;
      return super.routerWillLeave(nextLocation);
    }
  }

  _onAddNoteClicked(student) {
    this.setState({ dialogOpen: student });
  }

  _onCancelNoteClicked() {
    this.setState({ dialogOpen: false });
  }

  _onSaveNoteClicked(note) {
    const studentId = this.state.dialogOpen.studentGeneralInfo.id;
    this.props.submitStudentNote(studentId, {
      groupId: this.props.groupId,
      category: notesActions.STUDENT_NOTE_CATEGORY_PROGRESS_TEST,
      content: note,
      entityId: this.props.progressTestId,
    });
    this.setState({ dialogOpen: false });
  }

  _buildViewState(props, extraState = {}) {
    if (!ApiResponseHelper.hasSucceeded(props.progressTest)) {
      return;
    }
    this.setState(
      Object.assign(
        {
          studentProgressTestResult:
            props.progressTest.data.studentProgressTestResults,
          studentChanged: [],
          wasAnEditMade: false,
        },
        extraState,
      ),
    );
  }

  _wasAnAddReallyMade() {
    const getOriginalScore = (studentId, skillId) =>
      this.props.progressTest.data.studentProgressTestResults
        .get(studentId)
        .skillResults.get(skillId).currentResult;
    return this.state.studentProgressTestResult.some(
      (studentProgressTestResult, studentId) =>
        studentProgressTestResult.skillResults.some(
          (skillResult, skillId) =>
            is.number(skillResult.currentResult) &&
            is.not.number(getOriginalScore(studentId, skillId)),
        ),
    );
  }

  _isChangesPresent() {
    return (
      ProgressTestCourseView.isInMarkingRoute(this.props) &&
      (this.state.wasAnEditMade || this._wasAnAddReallyMade())
    );
  }

  _handleSave(
    studentProgressTestResults = this.state.studentProgressTestResult,
  ) {
    const {
      submitProgressTestResults,
      currentProgressTestPlan,
      progressReportId,
      params,
      isUnitQuiz,
    } = this.props;
    const progressTest = ProgressTest.serialize(
      ProgressTest.create({
        studentProgressTestResults,
      }),
    );
    return submitProgressTestResults(
      params.groupId,
      currentProgressTestPlan.id,
      progressTest,
      progressReportId,
      isUnitQuiz,
    );
  }

  _onRubricButtonClicked(studentId, skillId) {
    const {
      pushRoute,
      buildRoute,
      progressTest,
      currentProgressTestIndex,
      params: { groupId },
    } = this.props;
    const progressTestSkills = progressTest.data.skills;
    const skillIndex = progressTestSkills.findIndex(
      (pt) => pt.skillId === skillId,
    );
    pushRoute(
      buildRoute(
        `/group/${groupId}` +
          `/exam-hfv4/${currentProgressTestIndex}` +
          `/student/${studentId}` +
          `/skill/${skillIndex}`,
      ),
    );
  }

  _onIndividualScoreEdited(studentId, skillId, fullMark, newScoreText) {
    const originalScore =
      this.props.progressTest.data.studentProgressTestResults
        .get(studentId)
        .skillResults.get(skillId).currentResult;
    const newScoreInt = Number.parseFloat(newScoreText);
    const newScoreNum = is.number(newScoreInt) ? newScoreInt : null;
    const updatedStudentProgressTestResult =
      this.state.studentProgressTestResult.update(studentId, (student) =>
        student.update("skillResults", (skillResults) =>
          skillResults.update(skillId, (skillResult) =>
            skillResult.set("currentResult", newScoreNum),
          ),
        ),
      );
    const newState = {
      studentProgressTestResult: updatedStudentProgressTestResult,
    };
    if (
      this.state.studentChanged.findIndex((ele) => ele === studentId) === -1
    ) {
      const studentChanged = this.state.studentChanged;
      studentChanged.push(studentId);
      newState.studentChanged = studentChanged;
    }
    if (is.number(originalScore)) {
      newState.wasAnEditMade = true;
    }
    this.setState(newState);
  }

  _getTotalAsPercentageOrHyphen(resultsDescriptor = {}) {
    const { totalScore = {} } = resultsDescriptor;
    if (
      !is.object(totalScore) ||
      totalScore.isEmpty ||
      totalScore.isNotApplicable
    ) {
      return EMPTY_HYPHEN;
    }
    return totalScore.percentage;
  }

  _renderTotalsAsPercentages(results) {
    const currentTotalPercentage = this._getTotalAsPercentageOrHyphen(results);
    return (
      <div
        className={classnames(
          styles.ProgressTestCourseView_scoreCell,
          testClass("average-score"),
        )}
      >
        <div className={styles.ProgressTestCourseView_scoreCell_currentScore}>
          {is.number(currentTotalPercentage)
            ? `${currentTotalPercentage}%`
            : currentTotalPercentage}
        </div>
      </div>
    );
  }
  _exportAssessmentReport() {
    console.log("A_exportAssessmentReportss");
  }
  _gaLinkToReport() {
    ReactGA.event({
      category: "Progress Tests",
      action: "Clicked linked to progress report",
    });
  }
  _gaLinkToRetakePT() {
    ReactGA.event({
      category: "Progress Tests",
      action: "Clicked button to retake PT",
    });
  }

  _renderScoresForSkill(result, progressTestSkill, studentId, canBeOverwrite) {
    const { skillId } = progressTestSkill;
    const isScoreEmpty = (score) => !is.number(score);
    const renderScores = (score, previousScore, fullMark) => {
      const isEditableScore =
        ProgressTestCourseView.isInMarkingRoute(this.props) &&
        !progressTestSkill.isRubric &&
        canBeOverwrite;
      const editScoreCellClassName = progressTestSkill.isRubric
        ? ""
        : testClass("non-rubric");
      if (!isEditableScore && isScoreEmpty(score)) {
        return (
          <div className={styles.ProgressTestCourseView_scoreCell}>
            <div
              className={styles.ProgressTestCourseView_scoreCell_currentScore}
            >
              {`-/${fullMark}`}
            </div>
          </div>
        );
      }
      const onIndividualScoreEditedKey = `${studentId}-${skillId}`;
      const onIndividualScoreEdited =
        this._onIndividualScoreEditedCache[onIndividualScoreEditedKey] ||
        (this._onIndividualScoreEditedCache[onIndividualScoreEditedKey] =
          this._onIndividualScoreEdited.bind(
            this,
            studentId,
            skillId,
            fullMark,
          ));
      return (
        <EditableScoreCell
          className={editScoreCellClassName}
          score={score}
          previousScore={previousScore}
          isEditableScore={isEditableScore}
          showAsPercentage={!ProgressTestCourseView.isInMarkingRoute(this.props)}
          studentId={studentId}
          skillId={skillId}
          fullMark={fullMark}
          onChange={onIndividualScoreEdited}
        />
      );
    };
    const scoresReadout = renderScores(
      result.currentResult,
      result.previousResult,
      isScoreEmpty(result.fullMark)
        ? progressTestSkill.fullMark
        : result.fullMark,
    );
    const rubricButtonClassNames = classnames(
      styles.ProgressTestCourseView_scoreCell,
      styles.__isRubric,
      testClass("rubric-score"),
    );
    if (progressTestSkill.isRubric) {
      return (
        <Button
          className={rubricButtonClassNames}
          disabled={
            (!this.props.isUnitQuiz &&
              progressTestSkill.name === shouldDisabledSkillName) ||
            !canBeOverwrite
          }
          onClick={() => this._onRubricButtonClicked(studentId, result.skillId)}
          attrs={{ tabIndex: "-1" }}
        >
          {scoresReadout}
          <Icon
            id="arrow-right"
            className={styles.ProgressTestCourseView_scoreCell_icon}
          />
        </Button>
      );
    }
    return scoresReadout;
  }

  _renderScoresInfoForSkill(skillResult) {
    if (!skillResult.isRubric && skillResult.currentResult) {
      const { timeZone } = this.props;
      return (
        <div>
          <p>
            {skillResult.markedBy
              ? `Marked by ${skillResult.markedBy}`
              : "Synced from PT App"}
          </p>
          <p>
            On{" "}
            {moment
              .utc(skillResult.markedTime)
              .clone()
              .tz(timeZone)
              .format("YYYY-MM-DD")}
          </p>
        </div>
      );
    }
    return <div>-</div>;
  }

  _findProgressTestResultsForStudent(progressTestResults, studentId) {
    return progressTestResults.get(studentId);
  }

  _renderAssessmentReportInstruction() {
    return (
      <Tooltip
        text={AssessmentReportInstruction}
        placement="left"
        trigger={["hover", "click", "focus"]}
        className={styles.ProgressTestCourseView_tooltip}
        overlayClassName={styles.ProgressTestCourseView_tooltip_inner}
      >
        <Icon
          id="question"
          className={styles.ProgressTestCourseView_tooltip_icon}
        />
      </Tooltip>
    );
  }

  _renderUnsavedChangesWarningDialog() {
    let isSaving = false;
    return (
      <UnsavedChangesWarning
        isOpen={!!this._isNavigationWithChangesRequested()}
        isSaving={this.props.isAnyApiCallSaving || isSaving}
        onSaveClicked={() => {
          isSaving = true;
          this._handleSave(
            this.lastStateBeforeRouteChange.filter(
              (result) => !!result.canBeOverwrite,
            ),
          ).then(() => {
            isSaving = false;
          });
          this._forcePushRequestedLocation();
        }}
        onDiscardClicked={() => {
          this._forcePushRequestedLocation();
        }}
        onCloseClicked={() => {
          this._clearRequestedLocation();
        }}
      />
    );
  }

  _fetchProgressTestModels(props = this.props) {
    const { progressTest, progressReports, currentProgressTestPlan } = props;
    if (!currentProgressTestPlan) return;
    const { groupId } = props.params;
    if (ApiResponseHelper.shouldFetch(progressTest)) {
      props.fetchProgressTest(groupId, currentProgressTestPlan);
    }
    if (ApiResponseHelper.shouldFetch(progressReports)) {
      props.fetchProgressReport(groupId);
    }
  }

  _renderCell(member, column, isShowScoreInfo) {
    const progressTestResults = this._findProgressTestResultsForStudent(
      this.state.studentProgressTestResult,
      member.studentGeneralInfo.id,
    );

    const skill = this.props.progressTest.data.skills.find(
      (skillIt) => skillIt.name === column,
    );

    if (is.undefined(progressTestResults)) {
      return null;
    }

    if (is.not.undefined(skill)) {
      const testResult = progressTestResults.skillResults.get(skill.skillId);
      if (isShowScoreInfo) {
        return this._renderScoresInfoForSkill(testResult);
      }
      return this._renderScoresForSkill(
        testResult,
        skill,
        member.studentGeneralInfo.id,
        progressTestResults.canBeOverwrite,
      );
    }

    switch (column) {
      case "total":
        return this._renderTotalsAsPercentages(progressTestResults);
      case "export-pdf":
        return (
          <div className={testClass("report-link-cell")}>
            {this._renderExportLink(member, progressTestResults)}
          </div>
        );
      case "unit-report":
        return (
          <div className={testClass("report-link-cell")}>
            {this._renderReportLink(member)}
          </div>
        );
      case "retake":
        return (
          <div className={testClass("report-link-cell")}>
            {this._renderRetakeLink(member)}
          </div>
        );
      case "study-report":
        return (
          <div className={testClass("report-link-cell")}>
            {this._renderStudyReport(member)}
          </div>
        );
      case "assessment-results":
        return (
          <div className={testClass("report-link-cell")}>
            {this._renderAssessmentResultsLink(member)}
          </div>
        );
      default:
        throw new Error(`Invalid column ${column}`);
    }
  }
  _renderAssessmentReportButton() {
    return (
      <Link onClick={() => this._exportAssessmentReport()}>
        <Icon id="export" />
      </Link>
    );
  }

  _renderExportLink(member, results) {
    const isOnlineCompleted = ONLINE_SKILLS.map((os) => {
      const skill = this.props.progressTest.data.skills.find(
        (s) => os.toUpperCase() === s.name.toUpperCase(),
      );
      return is.not.undefined(skill) ? skill.skillId : "-1";
    }).every((id) => {
      const testResult = results.skillResults.get(id);
      return testResult && !testResult.markedBy && testResult.currentResult;
    });
    const className = classnames(styles.GeneralLink, {
      [styles.__disabled]: !isOnlineCompleted || this.state.isExportInProgress,
    });
    return (
      <Link
        className={className}
        draggable={false}
        onClick={() =>
          this._onExportLinkClicked(member, results, isOnlineCompleted)
        }
        tabIndex="-1"
      >
        Export
      </Link>
    );
  }

  _onExportLinkClicked(member, results, isOnlineCompleted) {
    if (isOnlineCompleted) {
      this.setState({ isExportInProgress: true });
      fetch(
        buildUrl(
          `/progress-tests/${this.props.progressTestId}/students/${member.studentGeneralInfo.id}/pdf`,
        ),
      )
        .then((response) => {
          exporter
            .get(response.url, response.name, false, "application/pdf")
            .then(() => {
              this.setState({ isExportInProgress: false });
            })
            .catch(() => {
              this.setState({ isExportErrorOccurred: true });
              this.setState({ isExportInProgress: false });
            });
        })
        .catch(() => {
          this.setState({ isExportErrorOccurred: true });
          this.setState({ isExportInProgress: false });
        });
    } else {
      this.setState({ showExportWarningDialog: true });
    }
  }

  _renderExportWarningDialog() {
    if (this.state.showExportWarningDialog) {
      return (
        <AlertDialog
          isWarning
          content2="The quiz is not completed yet."
          okButtonContent="OK"
          onButtonClick={() => {
            this._onExportWarningClick();
          }}
        />
      );
    }
  }

  _renderExportGeneralErrorDialog() {
    if (this.state.isExportErrorOccurred) {
      return (
        <ErrorDialog
          isOpen
          onConfirmClick={() => {
            this._onEndExportWarningOrError();
          }}
        />
      );
    }
  }

  _onEndExportWarningOrError() {
    this.setState({ isExportErrorOccurred: false });
  }

  _onExportWarningClick() {
    this.setState({ showExportWarningDialog: false });
  }

  _renderExportLoading() {
    if (this.state.isExportInProgress) {
      return <PageLoadingSpinner isHidden={!this.state.isExportInProgress} />;
    }
  }

  _renderRetakeLink(member) {
    return (
      <Link
        className={styles.ProgressReportLink}
        draggable={false}
        onClick={() => this._onRetakeLinkClicked(member)}
        tabIndex="-1"
      >
        Retake Unit Quiz
      </Link>
    );
  }

  _onRetakeLinkClicked(student) {
    this.setState({ retakePTConfirmDialog: student });
  }

  _onCancelRetakeClicked() {
    this.setState({ retakePTConfirmDialog: false });
  }

  _onOKRetakeClicked() {
    this._gaLinkToRetakePT();
    const studentId = this.state.retakePTConfirmDialog.studentGeneralInfo.id;

    this.props.retakeProgressTest(
      this.props.groupId,
      { progressTestId: this.props.progressTestId, studentId },
      this.props.progressReportId,
    );
    this.setState({ retakePTConfirmDialog: false });
  }

  _renderReportLink(member) {
    const {
      progressReportId,
      params: { groupId },
      buildRoute,
    } = this.props;
    const memberId = member.studentGeneralInfo.id;

    const route = buildRoute(
      `/group/${groupId}/unit-report/${progressReportId}/student/${memberId}`,
      { mode: "" },
    );
    return (
      <Link
        className={styles.ProgressReportLink}
        to={route}
        draggable={false}
        onClick={() => this._gaLinkToReport()}
        tabIndex="-1"
      >
        Report{" "}
        <Icon id="arrow-right" className={styles.ProgressReportLink_icon} />
      </Link>
    );
  }

  _renderStudyReport(member) {
    const memberId = member.studentGeneralInfo.id;

    return (
      <Link
        className={styles.ProgressReportLink}
        draggable={false}
        onClick={() => this._redirectToStudyReport(memberId)}
        tabIndex="-1"
      >
        Study Results{" "}
        <Icon id="arrow-right" className={styles.ProgressReportLink_icon} />
      </Link>
    );
  }

  _renderAssessmentResultsLink(member) {
    const memberId = member.studentGeneralInfo.id;
    const { studentAssessmentReportBaseUrl } = this.props;
    const url = `${studentAssessmentReportBaseUrl}&studentId=${memberId}`;

    return (
      <a
        className={styles.ProgressReportLink}
        href={url}
        target="_blank"
        rel="noreferrer"
        draggable={false}
        tabIndex="-1"
      >
        Assessment Results{" "}
        <Icon id="arrow-right" className={styles.ProgressReportLink_icon} />
      </a>
    );
  }

  _redirectToStudyReport(memberId) {
    const { studyReportUrl } = this.props;

    fetch(buildUrl(`/students/${memberId}/study-report-token`))
      .then((response) => {
        const redirectUrl = `${studyReportUrl}?idTokenV2=${response.idToken}&accessTokenV2=${response.accessToken}&origin=learning`;
        window.open(redirectUrl, "_blank", "noreferrer");
      })
      .catch(() => {
        // do nothing.
      });
  }

  _renderRetakePTConfirmDialog() {
    if (!this.state.retakePTConfirmDialog) {
      return null;
    }

    const student = this.state.retakePTConfirmDialog;

    return (
      <ConfirmDialog
        isOpen
        primaryButtonContent="Confirm"
        secondaryButtonContent="Cancel"
        onPrimaryClick={() => this._onOKRetakeClicked(student)}
        onSecondaryClick={() => this._onCancelRetakeClicked()}
        onRequestClose={() => this._onCancelRetakeClicked()}
      >
        <span>
          {" "}
          This will clear the student this online progress test result! Are you
          sure? <br />
          (note the cleared result/new result will take a while to be synced to
          here. <br />
          Until then this view will still show the last result)
        </span>
      </ConfirmDialog>
    );
  }

  _renderAddNoteDialog(student) {
    if (this.state.dialogOpen !== student) {
      return null;
    }

    return (
      <NewNotePopup
        titleGroup={this.props.groupNumber}
        studentName={`${student.studentGeneralInfo.firstName} ${student.studentGeneralInfo.lastName}`}
        extraInfo={
          <QuickSummary
            type={QuickSummary.Type.progressTest}
            entityId={this.props.progressTestId}
          />
        }
        onSave={this._onSaveNoteClicked}
        onCancel={this._onCancelNoteClicked}
      />
    );
  }

  _renderExpandButtonForRemainingTable() {
    const { isExpandRemainingMember } = this.state;

    return (
      <ExpansionButton
        isExpand={isExpandRemainingMember}
        onExpansionButtonClick={() =>
          this.setState({ isExpandRemainingMember: !isExpandRemainingMember })
        }
        className={styles.ProgressTestCourseView_expand}
      />
    );
  }

  _renderExpandButtonForSocreInfoTable() {
    const { isExpandMembersInScoreInfo } = this.state;

    return (
      <ExpansionButton
        isExpand={isExpandMembersInScoreInfo}
        onExpansionButtonClick={() =>
          this.setState({
            isExpandMembersInScoreInfo: !isExpandMembersInScoreInfo,
          })
        }
        className={styles.ProgressTestCourseView_expand}
      />
    );
  }

  _renderPTTable(members) {
    const {
      isUnitQuiz,
      canReTakeProgressTest,
      canExportProgressTest,
      canViewUnitReport,
      canViewStudyReport,
      canViewStudentAssessmentReport,
      studyReportUrl,
    } = this.props;

    return (
      <CourseViewTable
        students={members}
        onlyRowDivider
        onAddNoteClicked={
          SHOW_ADD_STUDENT_NOTES_ICON && this.props.canAddStudentNotes ? this._onAddNoteClicked : undefined
        }
        renderAddNoteDialog={this._renderAddNoteDialog}
      >
        <CourseViewTable.Header>
          <CourseViewTable.Row>
            <CourseViewTable.Cell columnId="total" small>
              Total
            </CourseViewTable.Cell>
            {this.props.progressTest.data.skills.map(
              (skill) =>
                (isUnitQuiz || skill.name !== shouldDisabledSkillName) && (
                  <CourseViewTable.Cell
                    key={skill.name}
                    columnId={skill.name}
                    small
                  >
                    {skill.name === 'Speaking 1' ? 'Speaking' : skill.name}
                  </CourseViewTable.Cell>
                ),
            )}
            {isUnitQuiz && canExportProgressTest && (
              <CourseViewTable.Cell columnId="export-pdf" small>
                <span className={testClass("report-link-header")} />
              </CourseViewTable.Cell>
            )}
            {isUnitQuiz && canReTakeProgressTest && (
              <CourseViewTable.Cell columnId="retake" small>
                <span className={testClass("report-link-header")} />
              </CourseViewTable.Cell>
            )}
            {isUnitQuiz && canViewUnitReport && (
              <CourseViewTable.Cell columnId="unit-report" small>
                <span className={testClass("report-link-header")} />
              </CourseViewTable.Cell>
            )}
            {isUnitQuiz &&
              canViewStudyReport &&
              is.not.undefined(studyReportUrl) && (
                <CourseViewTable.Cell columnId="study-report" small>
                  <span className={testClass("report-link-header")} />
                </CourseViewTable.Cell>
              )}
            {canViewStudentAssessmentReport && (
              <CourseViewTable.Cell columnId="assessment-results" small>
                <span className={testClass("report-link-header")} />
              </CourseViewTable.Cell>
            )}
          </CourseViewTable.Row>
        </CourseViewTable.Header>
        <CourseViewTable.Body>
          {(member, column) => this._renderCell(member, column, false)}
        </CourseViewTable.Body>
      </CourseViewTable>
    );
  }

  _renderPTScoreInfoTable(members) {
    return (
      <CourseViewTable
        students={members}
        onlyRowDivider
        onAddNoteClicked={
          SHOW_ADD_STUDENT_NOTES_ICON && this.props.canAddStudentNotes ? this._onAddNoteClicked : undefined
        }
        renderAddNoteDialog={this._renderAddNoteDialog}
      >
        <CourseViewTable.Header>
          <CourseViewTable.Row>
            {this.props.progressTest.data.skills.map((skill) => {
              if (skill.isRubric) {
                return null;
              }
              return (
                <CourseViewTable.Cell
                  key={skill.name}
                  columnId={skill.name}
                  small
                >
                  {skill.name}
                </CourseViewTable.Cell>
              );
            })}
          </CourseViewTable.Row>
        </CourseViewTable.Header>
        <CourseViewTable.Body>
          {(member, column) => this._renderCell(member, column, true)}
        </CourseViewTable.Body>
      </CourseViewTable>
    );
  }

  render() {
    if (
      !List.isList(this.props.members) ||
      !this.props.progressTest ||
      !this.props.progressTest.data
    ) {
      return null;
    }

    let remainingMembers = [];
    if (this.state.isExpandRemainingMember) {
      remainingMembers = this.props.remainingMembers;
    }

    let ptMembers = [];
    if (this.state.isExpandMembersInScoreInfo) {
      ptMembers = this.props.ptSessionMembers.concat(
        this.props.remainingMembers,
      );
    }

    return (
      <div>
        <PageCard>
          <PageCard.Heading
            text={"Assessment Session Members"}
            className={styles.ProgressTestCourseView_cardHeader}
            titleClassName={styles.ProgressTestCourseView_cardHeader_title}
          >
            {(
              <RcTooltip
                placement="right"
                trigger={["hover"]}
                destroyPopupOnHide
                visible={this.state.benchmarkingTooltipVisible}
                onVisibleChange={(visible) =>
                  this.setState({ benchmarkingTooltipVisible: visible })
                }
                overlayClassName={styles.BenchmarkingTooltip_overlay}
                overlay={
                  <div className={styles.BenchmarkingTooltip}>
                    <div className={styles.BenchmarkingTooltip_title}>
                      Benchmarking
                    </div>
                    {BENCHMARKING_DATA.map((item, index) => (
                      <div
                        key={index}
                        className={styles.BenchmarkingTooltip_row}
                      >
                        <div className={styles.BenchmarkingTooltip_range}>
                          {item.range}
                        </div>
                        <div className={styles.BenchmarkingTooltip_content}>
                          <div
                            className={styles.BenchmarkingTooltip_category}
                          >
                            {item.category}
                          </div>
                          <div
                            className={styles.BenchmarkingTooltip_descriptor}
                          >
                            {item.descriptor}
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className={styles.BenchmarkingTooltip_footer}>
                      <span
                        className={styles.BenchmarkingTooltip_gotIt}
                        onClick={() =>
                          this.setState({ benchmarkingTooltipVisible: false })
                        }
                      >
                        Got it
                      </span>
                    </div>
                  </div>
                }
              >
                <div
                  className={styles.ProgressTestCourseView_cardHeader_tooltip}
                >
                  <Icon id="info" />
                </div>
              </RcTooltip>
            )}
          </PageCard.Heading>
          <PageCard.Content className={styles.ProgressTestCourseView_content}>
            {this._renderPTTable(this.props.ptSessionMembers)}
          </PageCard.Content>
        </PageCard>

        {SHOW_REMAINING_MEMBERS_CARD && (
          <PageCard>
            <PageCard.Heading
              text="Remaining Session Members"
              className={styles.ProgressTestCourseView_cardHeader}
            />
            <PageCard.Content className={styles.ProgressTestCourseView_content}>
              {this._renderPTTable(remainingMembers)}
            </PageCard.Content>
            {this._renderExpandButtonForRemainingTable()}
          </PageCard>
        )}
        {SHOW_EXAM_LOG_CARD && (
          <PageCard>
            <PageCard.Heading
              text={this.props.isUnitQuiz ? "Unit Quiz Log" : "Exam Log"}
              className={styles.ProgressTestCourseView_cardHeader}
            />
            <PageCard.Content className={styles.ProgressTestCourseView_content}>
              {this._renderPTScoreInfoTable(ptMembers)}
            </PageCard.Content>
            {this._renderExpandButtonForSocreInfoTable()}
          </PageCard>
        )}
        {this._renderUnsavedChangesWarningDialog()}
        {this._renderRetakePTConfirmDialog()}
        {this._renderExportWarningDialog()}
        {this._renderExportGeneralErrorDialog()}
        {this._renderExportLoading()}
      </div>
    );
  }
}

ProgressTestCourseView.isInMarkingRoute = (props) =>
  props.params && props.params.mode === MARKING;

ProgressTestCourseView.propTypes = {
  timeZone: PropTypes.string.isRequired,
  contentMap: PropTypes.object.isRequired,
  progressTest: PropTypes.object.isRequired,
  currentProgressTestIndex: PropTypes.number.isRequired,
  members: PropTypes.object.isRequired,
  ptSessionMembers: PropTypes.object.isRequired,
  remainingMembers: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  currentProgressTestPlan: PropTypes.object.isRequired,
  progressReportId: PropTypes.string,
  submitProgressTestResults: PropTypes.func.isRequired,
  buildRoute: PropTypes.func,
  pushRoute: PropTypes.func,
  router: PropTypes.any.isRequired,
  route: PropTypes.any.isRequired,
  routes: PropTypes.array.isRequired,
  pathName: PropTypes.string,
  location: PropTypes.object.isRequired,
  canViewUnitReport: PropTypes.bool,
  canViewStudyReport: PropTypes.bool,
  canReTakeProgressTest: PropTypes.bool,
  canExportProgressTest: PropTypes.bool,
  isAnyApiCallSaving: PropTypes.bool,
  groupNumber: PropTypes.string.isRequired,
  canAddStudentNotes: PropTypes.bool,
  progressTestId: PropTypes.string,
  studyReportUrl: PropTypes.string,
  canViewStudentAssessmentReport: PropTypes.bool,
  studentAssessmentReportBaseUrl: PropTypes.string,
  groupId: PropTypes.string,
  progressTestResetted: PropTypes.object.isRequired,
  isUnitQuiz: PropTypes.bool.isRequired,
};

export function mapStateToProps(state, ownProps) {
  const isUnitQuiz = checkIsUnitQuiz(ownProps.location.pathname);
  const { groupId } = ownProps.params;
  const { timeZone } = Group.getCentre(state, groupId);
  const pathName = ownProps.location.pathname;
  const group = state
    .get("rootReducer")
    .get("groups")
    .get(ownProps.params.groupId).data;
  const currentProgressTestIndex = Number.parseInt(
    ownProps.params.progressTestIndex,
    10,
  );
  const currentProgressTestPlan = getProgressTestPlanFromIndex(
    state,
    groupId,
    currentProgressTestIndex,
    isUnitQuiz,
  );
  const progressTest = getCurrentProgressTest(
    state,
    currentProgressTestPlan && currentProgressTestPlan.id,
  );
  const ptSessionStudentIds =
    progressTest &&
    progressTest.data &&
    progressTest.data.studentProgressTestResults
      .filter(
        (studentProgressTestResult) =>
          studentProgressTestResult.isPTSessionMember,
      )
      .map((studentProgressTestResult) => studentProgressTestResult.studentId);
  const remainingStudentIds =
    progressTest &&
    progressTest.data &&
    progressTest.data.studentProgressTestResults
      .filter(
        (studentProgressTestResult) =>
          !studentProgressTestResult.isPTSessionMember,
      )
      .map((studentProgressTestResult) => studentProgressTestResult.studentId);
  const progressReportId = ProgressTest.actions.getProgressReportId(
    state,
    groupId,
    currentProgressTestPlan && currentProgressTestPlan.id,
  );
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const ptSessionMembers =
    ptSessionStudentIds &&
    members.filter((member) =>
      ptSessionStudentIds.includes(member.studentGeneralInfo.id),
    );
  const remainingMembers =
    remainingStudentIds &&
    members.filter((member) =>
      remainingStudentIds.includes(member.studentGeneralInfo.id),
    );
  const canViewUnitReport =
    Group.isSupportUnitReport(state, groupId) &&
    PrivilegeChecker.hasPrivilege(state, Privileges.ProgressReport.View);
  const canViewStudyReport =
    Group.isSupportStudyReport(state, groupId) &&
    PrivilegeChecker.hasPrivilege(state, Privileges.ProgressReport.View);
  const canReTakeProgressTest =
    Group.isSupportPTRetaken(state, groupId) &&
    PrivilegeChecker.hasPrivilege(state, Privileges.ProgressTest.ReTake);
  const canAddStudentNotes = PrivilegeChecker.hasPrivilege(
    state,
    Privileges.AcademicInfo.AddStudentNotes,
  );
  const canExportProgressTest =
    Group.isSupportPTExportActions(state, groupId) &&
    ProgressTest.actions.enabledExportPT(currentProgressTestPlan);
  const progressTestId = currentProgressTestPlan && currentProgressTestPlan.id;
  const progressTestResetted = state
    .get("rootReducer")
    .get("isProgressTestResetted");
  const viewerLink = getViewerLink(state, progressTestId);
  const studyReportUrl = viewerLink && viewerLink.studyReportUrl;

  const assessmentBaseUrl = Config.get('hf4OnlineHomeworkViewerUrl');
  const examType = currentProgressTestPlan && getExamType(currentProgressTestPlan.name);
  const canViewStudentAssessmentReport = !!assessmentBaseUrl && !!examType;
  const studentAssessmentReportBaseUrl = canViewStudentAssessmentReport
    ? `${assessmentBaseUrl}/?type=${examType}&groupId=${groupId}`
    : null;

  return {
    groupId,
    timeZone,
    groupNumber: group.number,
    members,
    ptSessionMembers,
    remainingMembers,
    progressTest,
    currentProgressTestIndex,
    currentProgressTestPlan,
    progressReportId,
    pathName,
    canViewUnitReport,
    canViewStudyReport,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    canAddStudentNotes,
    canReTakeProgressTest,
    canExportProgressTest,
    progressTestId,
    progressReports: group && group.progressReports,
    studyReportUrl,
    canViewStudentAssessmentReport,
    studentAssessmentReportBaseUrl,
    progressTestResetted,
    isUnitQuiz,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(progressTestViewLinkActions, dispatch),
    bindActionCreators(SessionsAttendance.actions, dispatch),
    bindActionCreators(ProgressTest.actions, dispatch),
    bindActionCreators(progressTestActions, dispatch),
    bindActionCreators(progressReportsActions, dispatch),
    bindActionCreators(notesActions, dispatch),
  );
}

function isAnyApiCallSaving(state) {
  return !!(state.get("apiCalls") || new List())
    .filter((call, key) =>
      ["PUT", "POST"].some((method) => key.startsWith(method)),
    )
    .find((call) => ApiCall.State.isLoading(call));
}

function getCurrentProgressTest(state, progressTestId) {
  const progressTests = state.get("rootReducer").get("progressTests");
  if (!Map.isMap(progressTests)) {
    return;
  }
  return progressTests.get(progressTestId);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ProgressTestCourseView));



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/CourseView/component.jsx